export default __webpack_public_path__ + "images/referenzen/produktfilm/graeff_produktfilm.mp4";